<!--
 * @Description: newUploadFileMore文件上传组件--样式重写
 * @Author: fal
 * @FilePath: \xhlz_pc\src\project\components\newUploadFileMore.vue
 * @LastEditTime: 2025-08-30 14:47:03
-->
<template>
  <div class="flex" style="width: 100%">
    <el-upload
      v-show="!(limit && imgs.length == limit)"
      class="new-avatar-uploader"
      :action="url + uploadUrl"
      :show-file-list="false"
      :auto-upload="false"
      :multiple="multiple"
      v-loading="loading"
      :on-change="onFileChange"
      :before-upload="beforeUpload"
    >
      <img src="@/project/assets/plus-icon.png" alt="" class="icon-plus" />
    </el-upload>
    <div class="imgs flex" v-if="imgs.length > 0" :class="{ 'no-wrap': noWrap }" style="position: relative">
      <div
        v-for="(item, index) in imgs"
        class="ml-20 item"
        :key="index"
        :class="{ act: item.type !== 'image' && item.type !== 'video' }"
        :style="{
          width: item.type == 'image' || item.type == 'video' ? '' : '100px',
          margin: limit && limit == 1 ? '0' : '0 10px 10px 10px',
        }"
        style="border: 1px solid #e5e5e5; width: 100px; height: 100px; border-radius: 6px; overflow: hidden"
      >
        <el-image :src="item.url" v-if="item.type == 'image'" fit="cover" :preview-src-list="imgs.filter((item) => item.type == 'image').map((item) => item.url)" />
        <video autopay :src="item.url" v-else-if="item.type == 'video'"></video>
        <img v-else-if="item.type == 'xlsx'" src="@/assets/file/xlsx.png" />
        <img v-else-if="item.type == 'txt'" src="@/assets/file/txt.png" />
        <img v-else-if="item.type == 'doc'" src="@/assets/file/doc.png" />
        <img v-else-if="item.type == 'docx'" src="@/assets/file/docx.png" />
        <img v-else-if="item.type == 'zip'" src="@/assets/file/zip.png" />
        <img v-else-if="item.type == 'xls'" src="@/assets/file/xls.png" />
        <img v-else-if="item.type == 'rar'" src="@/assets/file/rar.png" />
        <img v-else-if="item.type == 'pdf'" src="@/assets/file/pdf.png" />
        <img v-else-if="item.type == 'dwg'" src="@/assets/file/dwg.png" />
        <img v-else src="@/assets/file/unknown.png" />
        <img v-if="!close" src="@/project/assets/icon-del.png" class="icon-close" @click="delImg(item, index)" />
      </div>
    </div>
    <div v-if="noWrap && showNum && imgs.length > showNum" class="image-count">(共 {{ imgs.length }} 张)</div>
  </div>
</template>

<script>
import { findType } from '@/project/utils/file.js';
export default {
  data() {
    return {
      uploadUrl: '',
      url: window.location.origin,
      imgs: [],
      loading: false,
    };
  },
  props: {
    close: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: () => [],
    },
    limit: {
      type: Number,
      default: 0,
    },
    // 文件是否不换行
    noWrap: {
      type: Boolean,
      default: false,
    },
    // 文件不换行时，显示n个后显示文件总数量
    showNum: {
      type: Number,
      default: 0,
    },
    allowedTypes: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    close(val) {
      if (val) {
        this.imgs = [];
      }
    },
    list: {
      handler(val) {
        this.imgs = [];
        if (val.length) {
          this.imgs = [];
          val.forEach((item) => {
            this.imgs.push({
              name: item.name,
              url: item.url,
              type: findType(item.url),
            });
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.uploadUrl = this.isAdmin ? '/admin/file/upload' : '/collective/file/upload';
  },
  methods: {
    // 删除文件
    delImg(item, index) {
      item.index = index;
      this.$deleteFile(this, item.url, this.isAdmin);
      this.$emit('fileDel', item);
      this.imgs.splice(index, 1);
    },
    // 文件校验
    beforeUpload(file) {
      // 获取文件后缀名
      const fileExtension = file.name.split('.').pop().toLowerCase();

      // 定义所有允许的图片和视频后缀
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
      const videoExtensions = ['mp4', 'webm', 'ogg'];

      let isAllowedType = false; // 初始化为 false

      // 根据 allowedTypes 的内容判断允许的类型
      if (this.allowedTypes.includes('image')) {
        isAllowedType = isAllowedType || imageExtensions.includes(fileExtension); // 逻辑或
      }
      if (this.allowedTypes.includes('video')) {
        isAllowedType = isAllowedType || videoExtensions.includes(fileExtension); // 逻辑或
      }

      // 如果没有指定 allowedTypes，允许所有类型
      if (this.allowedTypes.length === 0) {
        isAllowedType = true;
      }

      const isLtSize = file.size / 1024 < 500;

      if (!isAllowedType) {
        this.$message.error('文件类型不被允许');
        return false;
      }

      return true;
    },
    // 上传文件
    handleAvatarSuccess(file) {
      let formData = new FormData();
      formData.append('file', file.raw);
      this.loading = true;
      this.$request
        .post(this.uploadUrl, formData)
        .then((res) => {
          this.loading = false;
          if (file.raw.type.indexOf('image') > -1) {
            this.imgs.push({
              url: URL.createObjectURL(file.raw),
              type: 'image',
            });
          } else if (file.raw.type.indexOf('video') > -1) {
            this.imgs.push({
              url: URL.createObjectURL(file.raw),
              type: 'video',
            });
          } else {
            this.imgs.push({ url: file.name, name: '' });
          }
          this.$emit('fileurl', {
            res: res,
            title: file.raw.name,
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onFileChange(file) {
      if (this.beforeUpload(file)) {
        this.handleAvatarSuccess(file);
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-form-item__content {
  line-height: normal;
}

video {
  width: 88px;
  height: 84px;
}

.imgs {
  line-height: 30px;
  display: flex;
  flex-wrap: wrap;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
}
.item {
  margin: 0 10px 10px 10px;
}

.no-wrap {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  flex-wrap: nowrap;
  width: 100%;
}

.imgs div {
  flex: none;
  width: 100px;
  height: 100px;
}

.image-count {
  margin: 0 15px 0 5px;
  position: relative;
  right: 0;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 100px;
  color: rgba(153, 153, 153, 1);
  text-align: center;
  width: 50px;
  white-space: nowrap;
}
</style>
<style lang="less">
.new-avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  line-height: 100px;
  background-color: rgba(237, 237, 237, 0.4);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.new-avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.icon-plus {
  color: #e5e5e5;
  width: 40px;
  height: 40px;
  vertical-align: middle;
  text-align: center;
}

.imgs div {
  position: relative;

  img {
    width: 100px;
    height: 100px;
  }

  .icon-close {
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
    color: #333;
    width: 24px;
    height: 24px;
  }
}
</style>
